   <!-- Re-Authentication Dialog -->
    <div class="component-container">
    <div class="reauth-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Confirm Your Identity</h2>
            <button class="close-button" id="closeDialog" (click)="close()">&times;</button>
        </div>
        <div class="dialog-body">
            <div class="security-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span>Security verification required</span>
            </div>

            <p class="dialog-message">
                For your security, please confirm your password before continuing with this sensitive action.
            </p>

            <form #reAuthForm="ngForm" (ngSubmit)="onReAuth(reAuthForm)">
                <div class="form-group">
                    <label for="password">Password</label>
                    <div class="input-wrapper">
                        <input [type]="show ? 'text' : 'password'" name="password" placeholder="Enter your password" [(ngModel)]="password" required>
                        <button type="button" class="toggle-password" id="togglePassword" (click)="toggle()">Show</button>
                    </div>
                    <div id="passwordError" [ngClass]="{ 'error-message' : !showErr, 'error-message.visable' : showErr }">Incorrect password. Please try again.</div>
                </div>

                <div class="remember-device">
                    <input type="checkbox" id="rememberDevice">
                    <label for="rememberDevice">Don't ask again on this device for 30 days</label>
                </div>

                <button type="submit" class="btn btn-primary" id="confirmButton">
                    <span class="spinner"></span>
                    <span>Confirm</span>
                </button>
                
            </form>
        </div>
        <div class="dialog-footer">
            <button class="btn btn-secondary" id="cancelButton" (click)="close()">Cancel</button>
           
        </div>
    </div>

</div>